module.exports = __webpack_public_path__ + "img/logo.a538fa8a.jpg";